import { render, staticRenderFns } from "./RemoveTaskModal.vue?vue&type=template&id=22310834"
import script from "./RemoveTaskModal.vue?vue&type=script&lang=js"
export * from "./RemoveTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports